export const BUDGET = (communityId: string) =>
  `v1/community/${communityId}/budgets`;
